// extracted by mini-css-extract-plugin
export default {"tabsToggles":"style_tabsToggles__wwzdI"};